import Typography from '@hellodarwin/core/lib/components/common/typography';
import styled from 'styled-components';
export const AcceptedApplicationContainer = styled.div `
  width: 1036px;
  height: fit-content;
  min-height: ${({ isSectionAccessible }) => isSectionAccessible ? 'none' : '240px'};
  row-gap: 16px;
  column-gap: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  align-items: center;
  justify-items: center;
  filter: ${({ isSectionAccessible }) => isSectionAccessible ? 'none' : 'blur(4px)'};
  pointer-events: ${({ isSectionAccessible }) => isSectionAccessible ? 'auto' : 'none'};

  @media (max-width: 1510px) {
    width: 100%;
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 1000px) {
    width: 100%;
    grid-template-columns: 1fr;
  }
`;
export const NoDataTitle = styled(Typography) `
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey_2};
`;
export const NoDataDescription = styled(Typography) `
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey_3};
`;
export const CenteredDiv = styled.div `
  grid-column: 1 / -1;
  justify-self: center;
  width: 100%;
`;
